// Modal "Partager" : titre, QR code de la page du jeu, une seule phrase — rien d'autre.
// Le QR code encode la page officielle (GAME_URL, config/gameUrl.js), jamais l'adresse de la page ouverte, comme ZERO KAMI.
// En dev, si GAME_URL est une adresse de loopback (VITE_GAME_URL=http://localhost:5173/), elle est remplacée par l'adresse
// réseau local injectée par Vite (<meta name="dev-lan-url">, voir vite.config.js), pour ouvrir le jeu sur un téléphone.
import { $, show, hide } from './dom.js';
import { renderQrCode } from './qrcode.js';
import { resolveShareUrl } from '../core/network.js';
import { GAME_URL } from '../config/gameUrl.js';

const devLanUrl = () => document.querySelector('meta[name="dev-lan-url"]')?.content;

/** Adresse du QR code : la page du jeu (GAME_URL), une adresse locale de dev remplacée par celle du réseau local. */
export function shareUrl(gameUrl = GAME_URL, lanUrl = devLanUrl()) {
  return resolveShareUrl(gameUrl, lanUrl);
}

export function createShareModal(url = shareUrl()) {
  const modal = $('shareModal');
  const qr = $('shareModalQr');

  let rendered = false;
  function open() {
    if (!rendered) {
      renderQrCode(qr, url);
      rendered = true;
    }
    show(modal);
  }

  return {
    open,
    close: () => hide(modal),
    btnOpen: $('btnShareApp'),
    btnClose: $('btnCloseShare'),
  };
}
